import React from 'react';
import {
    Switch,
    Route,
    useRouteMatch
} from 'react-router-dom';
import SelectServices from './steps/SelectServices';
import ProgressionBar from './progressionBar/ProgressionBar';
import SummarySubmit from './steps/SummarySubmit';
import SecondaryContract from './steps/SecondaryContract';
import PrimaryContract from './steps/PrimaryContract';
import YourInformation from './steps/YourInformation';
import PromotionCode from './steps/PromotionCode';
import { useSelector } from 'react-redux';
import { selectCompanyInfo } from '../../../store/reducers/companyInfoReducer';
import { countryCodes } from '../../../constants';
/* import useWindowSize from '../../registered/companyList/search/windowResize'; */

function Form() {
    const companyInformation = useSelector(selectCompanyInfo);
    let { path } = useRouteMatch();
    /* const size = useWindowSize(); */

    return (
        <div className="form_container">
            {/* {size.width <= 1100 ?
                <> */}
                    <div className="formSmall-choosenCompany"><span className="your-company-text">Your company:</span> {companyInformation?.name !== "" && <span>{companyInformation.name}</span>}</div>
                    <Switch>
                        <Route exact path={path}>
                            <div className="register_container_outer">
                                <ProgressionBar item={1} progression={path} />
                                <SelectServices />  
                            </div>
                        </Route>
                        <Route path={`/form/info`}>
                            <div className="register_container_outer">  
                                <ProgressionBar item={2} progression={`${path}/info`} />
                                <YourInformation countryCodeArr={countryCodes}/>
                            </div>
                        </Route>
                        <Route path={`${path}/primary`}>
                            <div className="register_container_outer">
                                <ProgressionBar item={3} progression={`${path}/primary`} />                        
                                <PrimaryContract countryCodeArr={countryCodes} />
                            </div>
                        </Route>
                        <Route path={`${path}/secondary`}>
                            <div className="register_container_outer">
                                <ProgressionBar item={3} progression={`${path}/secondary`} />
                                <SecondaryContract countryCodeArr={countryCodes} />
                            </div>
                        </Route>

                        <Route path={`${path}/nomination`}>
                            <div className="register_container_outer">  
                                <ProgressionBar item={4} progression={`${path}/nomination`} />
                                <PromotionCode companyInfo={companyInformation}/>
                            </div>
                        </Route>

                        <Route path={`${path}/summary`}>
                            <div className="register_container_outer">
                                <ProgressionBar item={5} progression={`${path}/summary`} />
                                <SummarySubmit />
                            </div>
                        </Route>
                    </Switch> 
                {/* </>
                : <></>
            } */}
        </div>
    );
}

export default Form;
